import { Component, OnInit, ViewChild } from '@angular/core';
import { first } from 'rxjs/operators';
import { PropertyService, Property } from '@app/_components/property';
import { AlertService, AuthenticationService, ConstantService, DataCacheService } from '@app/_services';
import { Router } from '@angular/router';
import { SelectItem, LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { Locations, ListingStatus, PropertyTypes, ListingTypes } from '@app/_helpers/constants';
import { Table } from 'primeng/table';
import { Dropdown } from 'primeng/dropdown';
import {ImportExportComponent} from '@app/_components/_helpers/import-export/import-export.component';
import * as moment from 'moment';
@Component({
    selector: 'app-property-list-details',
    templateUrl: './property-list-details.component.html',
    styleUrls: ['./property-list-details.component.css'],
    standalone: false
})
export class PropertyListDetailsComponent implements OnInit {
	@ViewChild('pt') pt: Table | undefined;
	@ViewChild('aa') public aa: Dropdown;
	datasource: Property[];
	property: Property;
	properties: Property[] = [];
	columns: any[];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	userStatusOptions: SelectItem[];

	// flags = [
	// 	{ value: 0, name: 'Active' },
	// 	{ value: 1, name: 'Suspended' },
	// ];

	listingStatuses = [
		{ value: 0, name: 'Active' },
		{ value: 2, name: 'Suspended' },
		{ value: 1, name: 'Canceled' }
	];

	propertyTypes = [
		{ value: '14', name: 'Single Family Home' },
		{ value: '01', name: 'Condominium' },
		{ value: '16', name: 'Townhome' }

	];

	listingTypes = [
		{ value: 1, name: 'Short Term Rental' },
		{ value: 2, name: 'Composite' },
		{ value: 3, name: 'Hotel Room Type' }
	];

    locations: any;
	sitePriorities: any;
	@ViewChild(ImportExportComponent) importExportComponent: ImportExportComponent;
	locationIds: any[];
	constructor(
		private authenticationService: AuthenticationService,
		private propertyService: PropertyService,
		private dataCacheService: DataCacheService,
		private alertService: AlertService,
		private confirmationService: ConfirmationService,
		private messageService: MessageService,
		private constantService: ConstantService,

		private router: Router
	) {
		this.locations = this.constantService.locations;
		this.sitePriorities = propertyService.sitePriorities;
		this.locationIds = this.constantService.locations;
	}


	ngOnInit() {
		try {
			this.columns = [
				{ field: 'shortTermRentalId', header: 'Id' },
				{ field: 'lastUpdate', header: 'Updated' },
				{ field: 'listingStatus', header: 'Status' },
				{ field: 'locationId', header: 'Location' },
				{ field: 'adrRegion', header: 'Region' },
				{ field: 'adrDistrictName', header: 'District' },
				{ field: 'propertyCode', header: 'Code' },
				{ field: 'adrBuildingName', header: 'Building' },
				{ field: 'floorOfProperty', header: 'Floor' },
				{ field: 'bedroomNum', header: 'Beds' },
				{ field: 'bathroomNum', header: 'Baths' },
				{ field: 'sleepsMax', header: 'Sleeps' },
			];
		} catch (error) {
			console.log('ngOnInit() ' + error);

		}
	}

	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			const pageNumber = Math.round(event.first / event.rows);
			this.propertyService.findAgentListByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					data => {
						console.log('properties are: ' + JSON.stringify(data));
						this.datasource = data.data.properties;
						this.recordTotal = data.page.recordTotal;
						this.properties = data.data.properties;
					},
					error => {
						console.log('properties list error!: ' + JSON.stringify(error));
						this.alertService.error(error);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.properties = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}
	onRowSelect(event) {
		try {
			this.loading = true;
			// console.log('onRowSelect(' + JSON.stringify(event) + ')');
			// use this for adding query params
			// this.router.navigate(['user-edit'], { queryParams: { userId: event.data.userId } });
			this.router.navigate(['property-edit', event.data.shortTermRentalId]);
		} catch (error) {
			console.log('onRowSelect(' + event + ')' + error);
		}
	}

	get Locations() {
		return Locations;
	}
	get ListingStatus() {
		return ListingStatus;
	}
	get PropertyTypes() {
		return PropertyTypes;
	}
	get ListingTypes() {
		return ListingTypes;
	}

	getlistingTypeName(property: any) {
		if (property?.listingType) {
			const status = this.listingTypes.find((e: any) => e.value == property.listingType);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getPropertyTypeName(property: any) {
		if (property?.propertyType) {
			const status = this.propertyTypes.find((e: any) => e.value == property.propertyType);
			return status.name;
		}
		else {
			return '';
		}
	}

	getPropertyListingStatus(property: any) {
		if (property?.listingStatus) {
			const status = this.listingStatuses.find((e: any) => e.value == property.listingStatus);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}



	onCopyToNewPropertyClick(property: any) {

		this.confirmationService.confirm({
			message: 'Are you sure you want to copy ' + property.propertyCode + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.copyToNewProperty(property)
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Copy canceled.', life: 3000 });
			}
		});
	}



	copyToNewProperty(property: any) {
		try {
			this.loading = true;

			this.propertyService.copyToNewProperty(property.shortTermRentalId)
				.subscribe(
					res => {
						console.log('copyToNewProperty SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success!', detail: res.message, sticky: false });
					},
					err => {
						console.log('property-find FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message, sticky: true });
						this.loading = false;
					},
					() => { this.loading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, sticky: true });
			this.loading = false;
		}
	}

	formUpdateProperty(property: any) {
		try {
			 console.log('property-before-updateS: ' + JSON.stringify(property));
			this.propertyService.update(property)
				.subscribe(
					res => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						// this.router.navigate(['/property-view', this.shortTermRentalId]);
					},
					err => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formUpdate(property: any) {
		try {
			 console.log('property-before-updateS: ' + JSON.stringify(property));

			this.propertyService.updateSitePriority(property)
				.subscribe(
					res => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						// this.router.navigate(['/property-view', this.shortTermRentalId]);
					},
					err => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => {  });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

    exportSelected($event: any) {
      this.importExportComponent.exporData($event, this.properties, 'Properties List');
    }

	loadLazyForExport(exporttype: string) {
		let event = this.lazyLoadEvent;
		event.rows = 1000;
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			const pageNumber = Math.round(event.first / event.rows);
			this.propertyService.findAgentListByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

				data => {
					console.log('properties are: ' + JSON.stringify(data));
					this.datasource = data.data.properties;
					this.recordTotal = data.page.recordTotal;
          let datList = data.data.properties;
          datList.forEach( data => {
            data.lastUpdate = moment.utc(data.lastUpdate).format('MM/DD/YYYY');
          });
					this.importExportComponent.exporData(exporttype, datList, 'Properties List');
				},
				error => {
					console.log('properties list error!: ' + JSON.stringify(error));
					this.alertService.error(error);
				},
				() => { this.loading = false; }
			);

			if (this.datasource) {
				this.properties = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	onCellEditInit(event: any): void { }
	onCellEditComplete(event: any): void { this.formUpdateProperty(event.data); }
	onCellEditCancel(): void { this.messageService.add({ severity: 'info', summary: 'Update Canceled', detail: 'No changes were saved' }); }
}
